export default __webpack_public_path__ + "static/media/client2.80ed401e.jpg";